/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * the list of parking near the institute
 * @export
 * @interface ParkingAvailable
 */
export interface ParkingAvailable {
    /**
     * the unique identifier of the doctor
     * @type {string}
     * @memberof ParkingAvailable
     */
    doctorUuid?: string;
    /**
     * the unique identifier of the parking
     * @type {string}
     * @memberof ParkingAvailable
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof ParkingAvailable
     */
    parking: string;
}

/**
 * Check if a given object implements the ParkingAvailable interface.
 */
export function instanceOfParkingAvailable(value: object): value is ParkingAvailable {
    if (!('parking' in value) || value['parking'] === undefined) return false;
    return true;
}

export function ParkingAvailableFromJSON(json: any): ParkingAvailable {
    return ParkingAvailableFromJSONTyped(json, false);
}

export function ParkingAvailableFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParkingAvailable {
    if (json == null) {
        return json;
    }
    return {
        
        'doctorUuid': json['doctorUuid'] == null ? undefined : json['doctorUuid'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'parking': json['parking'],
    };
}

export function ParkingAvailableToJSON(json: any): ParkingAvailable {
    return ParkingAvailableToJSONTyped(json, false);
}

export function ParkingAvailableToJSONTyped(value?: ParkingAvailable | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'doctorUuid': value['doctorUuid'],
        'uuid': value['uuid'],
        'parking': value['parking'],
    };
}

